/** ----------------------------------------
     State
 ---------------------------------------- */

import router from '@router/router';

const state = () => {
    return {
        data: [
            {
                active: true,
                id: 1,
                slug: 'miro',
                title: {
                    eng: 'Miro, for modern-day pioneers',
                    nl: 'Miro, samenwerken voor de moderne pionieer'
                },
                client: 'Miro',
                disciplines: [
                    'Strategy',
                    'Branding'
                ],
                color: '#F7CA30',
                images: {
                    logo: '',
                    featured: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87c10d58dadf0bfe8f71ffb1482695a0b11d5356a18.jpg',
                    case: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c8a62d6da0ca532ced25082535465ec345abc6452c74.gif'
                },
                contact: 'Sander Hidding',
                blocks: [
                    {
                        type: 'text',
                        options: {
                            id: 'strategy',
                            size: 'small',
                        },
                        content: {
                            title: {
                                eng: 'Miro, for modern-day pioneers',
                                nl: 'Miro, voor moderne poniers'
                            },
                            text: {
                                eng: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.',
                                nl: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                            }
                        }
                    },
                    {
                        type: 'image',
                        options: {
                            alt: '',
                            size: 'wide',
                        },
                        content: {
                            src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87baa0be3b527b69c8c2157697993874a430f62c049.jpg',
                        }
                    },
                    {
                        type: 'quote',
                        options: {
                            size: 'medium',
                        },
                        content: {
                            author: 'Barbra Gago, Chief Marketing Officer Miro',
                            text: {
                                eng: '"I was impressed with the teams speed, agility and vision, considering the conditions: working from 3 countries, timezones, in a short amount of time.”',
                                nl: '"I was impressed with the teams speed, agility and vision, considering the conditions: working from 3 countries, timezones, in a short amount of time.”'
                            }
                        }
                    },
                    {
                        type: 'video',
                        options: {
                            size: 'wide',
                        },
                        content: {
                            src: 'https://player.vimeo.com/video/321806747'
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            id: 'branding',
                            size: 'small',
                        },
                        content: {
                            title: {
                                eng: 'Miro, for modern-day pioneers',
                                nl: 'Miro, voor moderne poniers'
                            },
                            text: {
                                eng: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.',
                                nl: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                            }
                        }
                    },
                    {
                        type: 'image',
                        options: {
                            size: 'large',
                        },
                        content: {
                            alt: '',
                            src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87c10d58dadf0bfe8f71ffb1482695a0b11d5356a18.jpg',
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            size: 'small',
                        },
                        content: {
                            title: {
                                eng: 'Miro, for modern-day pioneers',
                                nl: 'Miro, voor moderne poniers'
                            },
                            text: {
                                eng: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.',
                                nl: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                            }
                        }
                    },
                    {
                        type: 'collage',
                        options: {
                            closed: true,
                            size: 'large',
                        },
                        content: {
                            images: [
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87aa25cc11abb206028046b29ce7dc42649aaf24107.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87a8e5443937703b26382d743be8da7243655e76c7e.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87a9fce0b551f0926aed820e511e28366c05eb14a60.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87aa05e3fec95ff58b92a6f911ce60661c83b57b3e3.gif',
                                }
                            ]
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            size: 'small',
                        },
                        content: {
                            title: {
                                eng: 'Miro, for modern-day pioneers',
                                nl: 'Miro, voor moderne poniers'
                            },
                            text: {
                                eng: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.',
                                nl: 'Rebranding an already loved and daily used platform like Miro doesn’t work without the input of its trailblazing users. We did extensive user research on online user behavior on the platform itself and questioned stakeholders and power users across the world to capture the building blocks and essential elements of the brand. <br><br> Power users described Miro as a solution for collaborating in a distributed, digital way with teams across the world. Also, they loved the supportive character of the Miro team. We took these characteristics and put them at the core of the new brand story of Miro. Besides being supportive, Miro also challenges its users to get on the same page by using the same professional language. In different strategic sessions, we transformed all insights into a clear strategic brand story that lays the foundation of the new brand platform and identity.'
                            }
                        }
                    },
                    {
                        type: 'parallax',
                        options: {
                            closed: true,
                            size: 'super',
                        },
                        content: {
                            images: [
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87aa25cc11abb206028046b29ce7dc42649aaf24107.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87a8e5443937703b26382d743be8da7243655e76c7e.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87a9fce0b551f0926aed820e511e28366c05eb14a60.gif',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5c87aa05e3fec95ff58b92a6f911ce60661c83b57b3e3.gif',
                                }
                            ]
                        }
                    },
                ]
            },
            {
                active: true,
                id: 2,
                slug: 'dutch-design-week',
                title: {
                    eng: 'It is always time for Dutch Design',
                    nl: 'Tijd voor Dutch Design'
                },
                client: 'Dutch Design Week',
                award: '3 Awards',
                disciplines: [
                    'Development',
                    'Digital Design'
                ],
                color: '#00f000',
                images: {
                    logo: '',
                    featured: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/2560x_5c1cff384efc805ce25e4b9ecbe4b229fdec6ff76a25d.jpg',
                    case: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/2560x_5c1cff384efc805ce25e4b9ecbe4b229fdec6ff76a25d.jpg'
                },
                contact: 'Sander Hidding',
                blocks: [
                    {
                        type: 'section',
                        options: {
                            size: 'small',
                        },
                        content: {
                            subtitle: 'Een nieuw community platform',
                            title: 'Dutch Design Week staat bekend als een van de meest inspirerende designfestivals ter wereld.',
                            text: 'Aan de hand van de Scrum-methode werken Vruchtvlees en Dutch Design Foundation nauw samen in het realiseren van de ambitieuze doelstellingen. In een intensieve backlogsessie brengen we alle wensen en eisen voor de website in kaart, uitgesplitst in concrete taken die de basis vormen voor opeenvolgende sprints.',
                            button: {
                                href: '#',
                                text: 'Lees het artikel'
                            }
                        }
                    },
                    {
                        type: 'collage',
                        options: {
                            closed: true,
                            size: 'large',
                        },
                        content: {
                            images: [
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5cd408475870e9b301595465578ebb98c3d1a3648eb2e.jpg',
                                },
                                {
                                    alt: '',
                                    src: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5cd4085a4744df2c8be498ee503da82710b358629cb40.jpg',
                                }
                            ]
                        }
                    },
                    {
                        type: 'text',
                        options: {
                            size: 'small',
                        },
                        content: {
                            title: 'Miro, for modern-day pioneers',
                            text: 'Miro is a visual collaboration tool used by 2 million users across the world. The worlds most innovative teams like Netflix, Twitter, Skyscanner, Cisco use Miro to create the next big ideas. Vruchtvlees has designed the new brand identity and strategic guidelines for Miro, formerly known as RealtimeBoard, that brings a human touch to the SaaS-tool. The visual language captures the joy of mutual understanding and focuses on bringing teams together, whether they are in the same room or on the other side of the world.'
                        }
                    }
                ]
            },
            {
                active: true,
                id: 3,
                slug: 'musuemnacht',
                title: {
                    eng: 'A light in the dark',
                    nl: 'Licht in het donker'
                },
                client: 'Museumnacht',
                disciplines: [
                    'Strategy',
                    'Branding',
                    'Development'
                ],
                color: '#E7325D',
                images: {
                    logo: '',
                    featured: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/57e90ddbbea10a064b0be75cd603f1a671d306ebac00e.jpg',
                    case: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/2560x_57a0575ac80d54f62214896be8b3f28afb848969d28e2.jpg'
                },
                contact: 'Giovanni Marchese',
            },
            {
                active: true,
                id: 4,
                slug: 'taqa',
                title: {
                    eng: 'A notable pair',
                    nl: 'Een prominent duo'
                },
                client: 'Theater de Vest / Grote Kerk Alkmaar',
                disciplines: [
                    'Branding'
                ],
                color: '#FEAED5',
                images: {
                    logo: '',
                    featured: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/uploads/5dc04bdddea9ff046c1ebcbba0b3768ebcbcd8d9ac78d.jpg',
                    case: 'https://vruchtvlees.ams3.cdn.digitaloceanspaces.com/thumbs/2560x_5d02228db0afe03e8b7716a53c6eb9a971ce1afb61915.jpg'
                },
                contact: 'Ted Godyla'
            },
        ]
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;